import { fakeLinkDownload } from 'commons/utils/download'
import { Request } from 'commons/utils/request'

export const downloadFile = ({
  method = 'post',
  baseUrl,
  parametersForm,
  direct,
  mimeType,
  name,
  handleError,
  onStart,
  onEnd
}: {
  method?: string
  baseUrl: string
  parametersForm: any
  direct?: boolean
  mimeType?: string
  name?: string
  handleError?: (error: string) => void
  onStart?: () => void
  onEnd?: () => void
}) => {
  const request = method === 'put' ? Request.put : Request.post
  onStart && onStart()

  request(baseUrl, parametersForm, {
    responseType: direct ? 'arraybuffer' : 'json',
    transformResponse: (data, headers) => {
      const disposition = headers?.['content-disposition']
      let filename: string | undefined
      if (disposition) {
        const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
        const matches = filenameRegex.exec(disposition)
        if (matches != null && matches[1]) {
          filename = matches[1].replace(/['"]/g, '')
        }
      }
      return {
        data,
        filename
      }
    }
  })
    .then((response: { data: any; filename: string | undefined }) => {
      const fileData = response?.data
      let url

      if (direct) {
        url = window.URL.createObjectURL(new Blob([fileData], { type: mimeType || 'image/jpg' }))
      } else {
        url = fileData?.link
      }

      fakeLinkDownload(url, response.filename || name)
    })
    .catch((error) => {
      const json =
        error.response && JSON.parse(String.fromCharCode.apply(null, new Uint8Array(error.response.data) as any))

      const message = error.message || 'Cannot download file'

      handleError && handleError(json && json.message ? json.message : message)
    })
    .finally(() => {
      onEnd && onEnd()
    })
}
